import React, { FC } from "react";
import { IconButton } from "@xapp/components";
import { StatusIncident } from "../models";
import style from "./style.scss";

export interface SiteAlertViewProps {
    incident: StatusIncident;
    onDismiss(): void;
}

export const SiteAlertView: FC<SiteAlertViewProps> = ({ incident, onDismiss }: SiteAlertViewProps) => {

    const incidentURL: string = incident.shortlink;
    const incidentMessage: string = incident.name;

    return (
        <div className={style.wrap}>
            <div className={style.inner}>
                <p>
                    {incidentMessage} {" "}
                    <a href={incidentURL} target="_blank" rel="noopener noreferrer">
                        Read More
                    </a>
                    .
                </p>
                <IconButton className={style.dismissButton} iconName="close" onClick={onDismiss} />
            </div>
        </div>
    );
};


/**
 * Reads the status page and alerts the site if an alert is present.
 */

